import { formatRoute } from 'react-router-named-routes';

import axios from '../config/axios';
import * as actionTypes from '../config/actionTypes';
import * as routes from '../config/routes';
import * as constants from '../config/constants';

import {
  getAuthHeaders,
  manageAuthActionError,
  storeUserData,
  storeAuthData,
} from '../auth/actions';
import {
  checkValidity,
  changeInputHandler,
  handleFormSubmit,
  updateFieldErrorsHandler,
} from '../common/utility';
import { Grid } from "@material-ui/core";
import InputField from "../common/components/inputField";
import React from "react";


export const toggleLoading = () => {
  return {
    type: actionTypes.TOGGLE_PROFILE_LOADING,
  };
};


export const toggleError = () => {
  return {
    type: actionTypes.TOGGLE_PROFILE_ERROR,
  };
};


export const updateProfileInputs = (section, data) => {
  return {
    type: actionTypes.UPDATE_PROFILE_INPUTS,
    payload: { section: section, data: data }  // eslint-disable-line
  };
};

export const updateBranchFieldStatus = (value) => {
  return {
    type: actionTypes.UPDATE_BRANCH_FIELD_STATUS,
    payload: { value },
  };
};

export const updateFieldErrors = (section, inputs, errorData) => {
  return (dispatch) => {
    const updatedInputs = updateFieldErrorsHandler(inputs, errorData);
    dispatch(updateProfileInputs(section, updatedInputs));
  };
};


export const updateNonFieldErrors = (errorData) => {
  return {
    type: actionTypes.UPDATE_PROFILE_ERRORS,
    payload: errorData,
  };
};


export const redirectToStep = (step, history, nextStep) => {
  console.log('action redirectToStep:::1', nextStep);
  nextStep = constants.SECTION_STEPS[nextStep];  // eslint-disable-line
  console.log('action redirectToStep:::2', nextStep);

  return () => {
    if (nextStep && step !== 'step-6' && step !== 'step-7') {
      history.replace({
        pathname: formatRoute(routes.COMPLETE_PROFILE, { step: nextStep }),
      });
    } else if(step === 'step-6'){
      history.replace({
        pathname: formatRoute(routes.PROFILE_STATUS),
      });
    } else {
      window.location.reload();
    }
  };
};


export const updateFiles = (files = []) => {
  return {
    type: actionTypes.UPDATE_FILES,
    payload: files,
  };
};


export const getSectionData = (section, token, inputs, history, siteId, editMode = false) => {
  return (dispatch) => {
    dispatch(toggleLoading());
    console.log("action===getSectionData===section", section);
    console.log("action===getSectionData===token", token);
    console.log("action===getSectionData===inputs", inputs);
    console.log("action===getSectionData===history", history);
    console.log("action===getSectionData===siteId", siteId);
    console.log("action===getSectionData===editMode", editMode);
    if (section === 'lifestyleinfo'){
      console.log('action===getSectionData===editMode===inIf');
      let section_report = 'report'
      let url = `/profiles/complete-profile/${section_report}?site_id=${siteId}`;
      if (editMode) {
        url = `/profiles/edit-profile/${section_report}?site_id=${siteId}`;
      }
      axios.get(url, getAuthHeaders(token))
        .then((response) => {
          dispatch(updateFiles(response.data.files));
        })
        .catch((error) => {
          dispatch(manageAuthActionError(error, token));
        });
    }

    let url = `/profiles/complete-profile/${section}?site_id=${siteId}`;
    if (editMode) {
      url = `/profiles/edit-profile/${section}?site_id=${siteId}`;
    }

    const step = constants.SECTION_STEPS[section];

    axios.get(url, getAuthHeaders(token))
      .then((response) => {
        if (!response.data.slug && step !== 'step-6' && step !== 'step-7' && step !== 'step-8') {
          const updatedControls = {};

          Object.keys(response.data).map((key) => {
            const input = { ...inputs[key] };
            if (input.type) {
              const validity = checkValidity(response.data[key], input.validation);
              input.value = response.data[key];
              input.valid = validity.isValid;
              input.errorMsg = validity.errorMsg;
              updatedControls[key] = input;
            }
            return null;
          });
          dispatch(updateBranchFieldStatus(response.data.hide_branch));
          dispatch(updateProfileInputs(section, updatedControls));
        } else if (!response.data.slug && (step === 'step-6')) {
          dispatch(updateFiles(response.data.files));
        } else if (!response.data.slug && (step === 'step-8')) {
          dispatch(updateFiles(response.data.files));
        } else if (!response.data.slug && step === 'step-7') {
          dispatch(updateFiles(response.data.files));
          const updatedControls = {};

          let key = 'id_proof_no'
          const input = { ...inputs[key] };
          if (input.type) {
            const validity = checkValidity(response.data.files[0][key], input.validation);
            input.value = response.data.files[0][key];
            input.valid = validity.isValid;
            input.errorMsg = validity.errorMsg;
            updatedControls[key] = input;
          }
          dispatch(updateBranchFieldStatus(response.data.hide_branch));
          dispatch(updateProfileInputs(section, updatedControls));
        }else if (!editMode) {
          dispatch(redirectToStep(step, history, response.data.slug));
        }
        if (section==='report'){
          dispatch(updateFiles(response.data.files));
        }
        dispatch(toggleLoading());
      })
      .catch((error) => {
        dispatch(toggleLoading());
        dispatch(manageAuthActionError(error, token));
      });
  };
};


export const inputChangedHandler = (event, field, section, inputs) => {
  console.log('inputChangedHandler===event',event);
  console.log('inputChangedHandler===field',field);
  console.log('inputChangedHandler===section',section);
  console.log('inputChangedHandler===inputs',inputs);
  return (dispatch) => {
    const updatedControls = changeInputHandler(
      event,
      inputs,
      field,
    );
    console.log('inputChangedHandler===updatedControls',updatedControls);
    dispatch(updateProfileInputs(section, updatedControls));
  };
};


const formatSectionData = (section, fieldData, editMode) => {
  console.log('formatSectionData===section',section);
  console.log('formatSectionData===fieldData',fieldData);
  let fields = { ...fieldData };

  if (section === 'basicinfo') {
    if (fields.bureau) {
      fields.bureau = fields.bureau.value;
    }
    fields.country_code = fields.country_code.value
  }
  if (section === 'personalinfo') {
    let birthDate = new Date(fields.birth_date);
    birthDate = `${birthDate.getFullYear()}-${birthDate.getMonth() + 1}-${birthDate.getDate()}`;
    fields.birth_date = birthDate;
    let birthTime = new Date(fields.birth_time);
    birthTime = `${birthTime.getHours()}:${birthTime.getMinutes()}`;
    fields.birth_time = birthTime;
    fields.birth_place = fields.birth_place;
    fields.caste = fields.caste.value;
    fields.marital_status = fields.marital_status.value;
  }
  if (section === 'lifestyleinfo') {
    fields.body_type = fields.body_type.value;
    fields.diet = fields.diet.value;
    fields.thalassemia = fields.thalassemia.value;
    fields.smoke = "";
    fields.drink = "";
  }
  if (section === 'educationinfo') {
    fields.qualification = fields.qualification.value;
    fields.profession = fields.profession.value;
    const degree = [...fields.degree];
    const qs = [];
    for (const q in degree) {
      qs.push(degree[q].value);
    }
    fields.degree = qs;
    fields.work_profile = fields.work_profile.value;
    fields.income = fields.income.value;
    fields.family_income = fields.family_income.value;
    fields.self_city = fields.self_city.value;
  }
  if (section === 'familyinfo') {
    fields.father_occupation = fields.father_occupation ? fields.father_occupation.value:'';
    fields.mother_occupation = fields.mother_occupation ? fields.mother_occupation.value:'';
    fields.family_city = fields.family_city.value;
    fields.residence_type = fields.residence_type.value;
  }
  if (section === 'contactinfo') {
    fields.self_city = fields.self_city.value;
    fields.family_city = fields.family_city.value;
    fields.residence_type = fields.residence_type.value;
  }
  if (section === 'photos' || section === 'pdfs') {
    const data = new FormData();
    data.append('file', fields.file);
    fields = data;
  }
  if (section === 'idproof') {
    console.log('action===formatSectionData');
    console.log('action===formatSectionData===fields',fields);
    console.log('action===formatSectionData===fields.id_proof_no',fields.id_proof_no);
    const data = new FormData();
    data.append('file', fields.file);
    if (fields.id_proof_no){
      data.append('id_proof_no', fields.id_proof_no);
    }
    if (fields.aadhaar_no){
      data.append('id_proof_no', fields.aadhaar_no);
    }
    fields = data;
  }
  if (section === 'report') {
    console.log('formatSectionData===report===fields', fields);
    console.log('formatSectionData===report===fields.file', fields.file);
    const data = new FormData();
    data.append('file', fields.file);
    fields = data;
  }
  if (section === 'partnerchoice') {
    const marital = [...fields.marital_status];
    const ms = [];
    for (const m in marital) {
      ms.push(marital[m].value);
    }
    fields.marital_status = ms;

    const caste = [...fields.caste];
    const cs = [];
    for (const c in caste) {
      cs.push(caste[c].value);
    }
    fields.caste = cs;

    const qualification = [...fields.qualification];
    const ql = [];
    for (const q in qualification) {
      ql.push(qualification[q].value);
    }
    fields.qualification = ql;

    const degree = [...fields.degree];
    const degrees = [];
    for (const d in degree) {
      degrees.push(degree[d].value);
    }
    fields.degree = degrees;

    const profession = [...fields.profession];
    const ps = [];
    for (const p in profession) {
      ps.push(profession[p].value);
    }
    fields.profession = ps;

    const workProfile = [...fields.work_profile];
    const wps = [];
    for (const w in workProfile) {
      wps.push(workProfile[w].value);
    }
    fields.work_profile = wps;

    const income = [...fields.income];
    const ins = [];
    for (const i in income) {
      ins.push(income[i].value);
    }
    fields.income = ins;

    const country = [...fields.country];
    const cnt = [];
    for (const cn in country) {
      cnt.push(country[cn].value);
    }
    fields.country = cnt;

    if (fields.diet) {
      fields.diet = fields.diet.value;
    }
    if (fields.smoke) {
      fields.smoke = fields.smoke.value;
    }
    if (fields.drink) {
      fields.drink = fields.drink.value;
    }
  }
  console.log('formatSectionData===fields', fields);
  return fields;
};


export const showSuccessMsg = (msg) => {
  return {
    type: actionTypes.SHOW_SUCCESS_MESSAGE,
    payload: msg,
  };
};


export const submitHandler = (event, section, inputs, token, history, siteId, editMode = false) => {
  return (dispatch) => {
    console.log('action===submitHandler');
    console.log('action===submitHandler===event',event);
    console.log('action===submitHandler===section',section);
    console.log('action===submitHandler===inputs',inputs);
    console.log('action===submitHandler===token',token);
    console.log('action===submitHandler===history',history);
    console.log('action===submitHandler===siteId',siteId);
    console.log('action===submitHandler===editMode',editMode);
    dispatch(toggleLoading());

    const result = handleFormSubmit(event, inputs);
    const step = constants.SECTION_STEPS[section];

    console.log('action===submitHandler===result',result);
    console.log('action===submitHandler===step',step);

    if (result.formError) {
      // frontend error
      dispatch(toggleError());
      dispatch(updateProfileInputs(section, result.inputs));
      dispatch(toggleLoading());
    }

    // no errors in frontend validation.. go ahead and axios it.
    if (Object.keys(result.fields).length === Object.keys(inputs).length) {
      const fields = formatSectionData(section, result.fields, editMode);

      console.log('action===submitHandler===fields',fields);

      let url = `/profiles/complete-profile/${section}?site_id=${siteId}`;
      if (editMode) {
        url = `/profiles/edit-profile/${section}?site_id=${siteId}`;
      }

      if (section === 'deleteProfile') {
        url = '/profiles/delete-profile';
      }

      axios.post(url, fields, getAuthHeaders(token))
        .then((response) => {
          dispatch(toggleLoading());
          if (section === 'deleteProfile') {
            window.location.href = '/';
          }
          if (editMode) {
            console.log('action===submitHandler===axios===if');
            console.log('action===submitHandler===axios===if===section', section);
            console.log('action===submitHandler===axios===if===token',token);
            console.log('action===submitHandler===axios===if===inputs',inputs);
            console.log('action===submitHandler===axios===if===history',history);
            console.log('action===submitHandler===axios===if===siteId', siteId);
            dispatch(showSuccessMsg('Your profile has been updated!'));
            dispatch(getSectionData(section, token, inputs, history, siteId, true));
            dispatch(storeUserData(response.data.user));
            dispatch(storeAuthData({
              token: token,  // eslint-disable-line
              user: response.data.user,
            }));
          } else {
            if(section !== 'photos') {
              dispatch(redirectToStep(step, history, response.data.next_step));
            }
            if(section === 'photos'){
              window.location.reload();
            }
          }
        })
        .catch((error) => {
          dispatch(toggleLoading());
          dispatch(toggleError());
          dispatch(updateFieldErrors(step, inputs, error.response.data));
          if (section === 'deleteProfile') {
            window.location.href = '/';
          }
          if (error.response && error.response.data && error.response.data.non_field_errors) {
            dispatch(updateNonFieldErrors(error.response.data.non_field_errors));
          }
        });
    }
  };
};


export const deleteFile = (fileID, token, editMode) => {
  return (dispatch) => {
    if (confirm('Are you sure you want to do this?')) {  // eslint-disable-line
      dispatch(toggleLoading());
      const url = '/profiles/delete-file';
      axios.post(url, { file_id: fileID }, getAuthHeaders(token))
        .then((response) => {
          dispatch(toggleLoading());
          if (editMode) {
            dispatch(storeUserData(response.data.user));
            dispatch(storeAuthData({
              token: token,  // eslint-disable-line
              user: response.data.user,
            }));
          }
          window.location.reload();
        })
        .catch((error) => {
          dispatch(toggleLoading());
          dispatch(updateNonFieldErrors(error.response.data.non_field_errors));
        });
    }
  };
};


export const onUnmount = () => {
  return {
    type: actionTypes.PROFILE_UNMOUNT,
  };
};


export const showProfileStatus = (data) => {
  return {
    type: actionTypes.SHOW_PROFILE_STATUS,
    payload: data,
  };
};


export const getProfileStatus = (token) => {
  return (dispatch) => {
    dispatch(toggleLoading());
    const url = '/profiles/status';
    axios.get(url, getAuthHeaders(token))
      .then((response) => {
        dispatch(toggleLoading());
        dispatch(storeUserData(response.data.user));
        dispatch(storeAuthData({
          token: token,  // eslint-disable-line
          user: response.data.user,
        }));
        dispatch(showProfileStatus(response.data));
      })
      .catch((error) => {
        dispatch(toggleLoading());
        dispatch(manageAuthActionError(error, token));
      });
  };
};


export const showProfileError = (error) => {
  return {
    type: actionTypes.SHOW_PROFILE_ERROR,
    payload: error,
  };
};

export const showProfile = (data) => {
  return {
    type: actionTypes.SHOW_PROFILE,
    payload: data,
  };
};


export const getProfile = (token, slug) => {
  return (dispatch) => {
    dispatch(toggleLoading());
    const url = `/profiles/view-profile/${slug}`;
    axios.get(url, getAuthHeaders(token))
      .then((response) => {
        dispatch(showProfile(response.data));
        dispatch(toggleLoading());
      })
      .catch((error) => {
        try {
          dispatch(manageAuthActionError(error, token));
        } catch (err) {
          dispatch(showProfileError('Something went wrong! Please contact support!'));
        }
        dispatch(toggleLoading());
      });
  };
};


export const setAvatar = (fileID, token) => {
  return (dispatch) => {
    if (confirm('Are you sure you want to do this?')) {  // eslint-disable-line
      dispatch(toggleLoading());
      const url = '/profiles/set-avatar';
      axios.post(url, { file_id: fileID }, getAuthHeaders(token))
        .then((response) => {
          dispatch(toggleLoading());
          dispatch(storeUserData(response.data.user));
          dispatch(storeAuthData({
            token: token,  // eslint-disable-line
            user: response.data.user,
          }));
          window.location.reload();
        })
        .catch((error) => {
          dispatch(toggleLoading());
          dispatch(updateNonFieldErrors(error.response.data.details));
        });
    }
  };
};



// WEBPACK FOOTER //
// ./src/profile/actions.js